export {default} from './WrappedPage';
